export default "__VITE_ASSET__31048831__"